import { CommercialType } from '@talon/web/lib/api';
import { Box, Button, Select, Text } from 'grommet';
import { Multimedia } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ModalCard } from '../ModalCard';
import { TalonInput } from '..';

export interface ICreateCommercialModalProps {
  addCommercial: (type: CommercialType, durationInSeconds: number, title?: string) => Promise<void>;
  setShowModal: (isVisible: boolean) => void;
}

export const CreateCommercialModal = observer(({ addCommercial, setShowModal }: ICreateCommercialModalProps) => {
  /** State **/
  const [title, setTitle] = useState('');
  const [type, setType] = useState<CommercialType>();
  const [durationInSeconds, setDurationInSeconds] = useState(0);

  /** Methods **/
  const createCommercial = () => {
    if (!type) return;
    addCommercial(type, durationInSeconds, title);
    setShowModal(false);
  };

  /** Render **/
  return (
    <ModalCard onClose={() => setShowModal(false)} title="Create Commercial">
      <Box gap="small">
        <Box>
          <Box direction="row" gap="small" pad="small" align="center" fill="horizontal">
            <Box width="28%">
              <Text>Title:</Text>
            </Box>
            <Box fill="horizontal">
              <TalonInput
                id="title"
                name="title"
                htmlFor="title"
                placeholder="New Commercial"
                val={title || ''}
                onChange={(val) => setTitle(val)}
              />
            </Box>
          </Box>

          <Box direction="row" gap="small" pad="small" align="center" fill="horizontal">
            <Box width="28%">
              <Text>Type:</Text>
            </Box>
            <Box fill="horizontal">
              <Select
                id="commercial-type"
                name="commercial-type"
                placeholder="Choose..."
                value={type}
                options={Object.values(CommercialType)}
                onChange={({ value }) => setType(value)}
                icon={<Multimedia />}
              />
            </Box>
          </Box>

          <Box direction="row" gap="small" pad="small" align="center" fill="horizontal">
            <Box width="28%">
              <Text>Duration:</Text>
            </Box>
            <Box fill="horizontal" direction="row" align="center" gap="xsmall">
              <TalonInput
                id="duration-in-seconds"
                name="duration-in-seconds"
                val={durationInSeconds}
                inputType="number"
                onChange={(val) =>
                  setDurationInSeconds(Number.isFinite(parseInt(val as string)) ? parseInt(val as string) : 0)
                }
              />
              <Text>seconds</Text>
            </Box>
          </Box>
        </Box>

        <Box direction="row" justify="end" align="center" margin={{ vertical: 'small' }}>
          <Button
            primary
            label="Add Commercial"
            disabled={!type || typeof durationInSeconds !== 'number'}
            onClick={() => createCommercial()}
          />
        </Box>
      </Box>
    </ModalCard>
  );
});
